var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon16PxEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.958 7.8C11.948 5.455 10.05 4 8 4 5.95 4 4.051 5.455 3.042 7.8c-.056.128-.056.272 0 .4C4.052 10.545 5.95 12 8 12c2.05 0 3.949-1.455 4.958-3.8.056-.128.056-.272 0-.4zM8 11c-1.584 0-3.084-1.145-3.949-3C4.916 6.145 6.416 5 8 5c1.584 0 3.084 1.145 3.949 3-.865 1.855-2.365 3-3.949 3zm0-5c-1.104 0-2 .895-2 2s.896 2 2 2 2-.895 2-2c0-.53-.211-1.04-.586-1.414C9.039 6.21 8.53 6 8 6zm0 3c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon16PxEye);
export default __webpack_public_path__ + "static/media/4-icon-16-px-eye.3c8e6614.svg";
export { ForwardRef as ReactComponent };